import { useCycleLocked } from '../lib/lock'
import { Icon, type IconName } from './Icon'
import { navigate, type Route } from '../lib/router'
import './BottomNav.css'

/**
 * Quatre destinations, plus le bouton d'ajout au centre.
 *
 * Le kit visuel en prévoit dix (tontines, famille, crédit, assurance,
 * objectifs, rapports…). Dix destinations contredisent frontalement la décision
 * produit « public peu habitué aux applications, peu de charge cognitive ».
 * Les features communautaires entreront plus tard derrière un écran dédié —
 * décision 2026-08-21.
 */

const ITEMS: Array<{ route: Route; icon: IconName; label: string }> = [
  { route: '/',             icon: 'home',   label: 'Accueil' },
  { route: '/transactions', icon: 'list',   label: 'Opérations' },
  { route: '/budget',       icon: 'wallet', label: 'Budget' },
  { route: '/profil',       icon: 'person', label: 'Profil' },
]

export function BottomNav({ current, onAdd }: { current: Route; onAdd: () => void }) {
  const [left, right] = [ITEMS.slice(0, 2), ITEMS.slice(2)]
  // La navigation reste ouverte, la saisie non : on peut tout consulter pendant
  // qu'une clôture attend, mais pas ajouter une opération qui déplacerait les
  // chiffres sur lesquels la clôture pose ses questions.
  const locked = useCycleLocked()

  return (
    <nav className="nav" aria-label="Navigation principale">
      {left.map((item) => <NavItem key={item.route} {...item} current={current} />)}

      <button type="button" className="nav-add" onClick={onAdd} disabled={locked}
              title={locked ? 'Fais d’abord le point du cycle écoulé' : undefined}>
        <Icon name="plus" size={26} />
        <span className="visually-hidden">Ajouter une opération</span>
      </button>

      {right.map((item) => <NavItem key={item.route} {...item} current={current} />)}
    </nav>
  )
}

function NavItem({ route, icon, label, current }:
  { route: Route; icon: IconName; label: string; current: Route }) {
  const active = current === route
  return (
    <button
      type="button"
      className="nav-item"
      // `aria-current` plutôt qu'une simple classe : l'état actif doit être
      // annoncé, pas seulement coloré.
      aria-current={active ? 'page' : undefined}
      onClick={() => navigate(route)}
    >
      <Icon name={icon} />
      <span>{label}</span>
    </button>
  )
}
